import React, { Suspense } from 'react';
import { useIntl } from 'react-intl';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { SgwtHelpCenter, SgwtMiniFooter, SgwtWidgetContextProvider } from '@sgwt/sgwt-widgets-react';
import { ErrorBoundary, Header } from './components/common';
import { Loading } from './components/common/Loading';
import { GlobalContext } from './context/GlobalContext';
import { IntlProvider } from './context/IntlContext';

import './App.scss';

// Lazy loading of sub-pages. With Vite.js, it creates separate JS bundles for each page,
// which are loaded only on demand when the user go on the corresponding page.
const Approach = React.lazy(() => import('./pages/Approach'));
const Homepage = React.lazy(() => import('./pages/Homepage'));
const JoinUs = React.lazy(() => import('./pages/JoinUs'));
const Works = React.lazy(() => import('./pages/Works'));
const Sitemap = React.lazy(() => import('./pages/Sitemap'));
const AccessibilityStatement = React.lazy(() => import('./pages/AccessibilityStatement'));

// const RequireConnectedUser = ({ children }: { children: JSX.Element }) => {
//   const intl = useIntl();
//   const user = useUser();
//   if (!user) {
//     return <Navigate to={`/${intl.locale}`} replace />;
//   }
//   return children;
// }

export const AppRoutes = () => {
  const intl = useIntl();
  return (
    <Routes>
      <Route path="/:language/approach" element={<Approach />} />
      <Route path="/:language/join-us" element={<JoinUs />} />
      <Route path="/:language/works" element={<Works />} />
      <Route path="/:language/sitemap" element={<Sitemap />} />
      <Route path="/:language/accessibility/" element={<AccessibilityStatement />} />
      <Route path="/:language/" element={<Homepage />} />
      <Route path="*" element={<Navigate to={`/${intl.locale}/`} />} />
      {/* <Route path="/:language/resources" element={
            <RequireConnectedUser>
              <Resources />
            </RequireConnectedUser>
        } /> */}
    </Routes>
  );
};

const Footer = () => {
  const intl = useIntl();
  const txt = intl.formatMessage({ id: 'sitemap.title' });
  return (
    <SgwtMiniFooter
      type="compact"
      accessibilityLink={`/${intl.locale}/accessibility`}
      accessibilityCompliance="full"
      about={`{'label':'${txt}','link':'/${intl.locale}/sitemap'}`}
      design="light"
      container="container"
      mode="sg-markets"
      contactUsByHelpCenter="sgwt-help-center"
    />
  );
};

export default function App() {
  return (
    <SgwtWidgetContextProvider infrastructure="azure">
      <ErrorBoundary>
        <Router>
          <IntlProvider>
            <GlobalContext.Provider value={{}}>
              <Header />
              <div className="flex-grow-1">
                <Suspense fallback={<Loading />}>
                  <AppRoutes />
                </Suspense>
              </div>
              <SgwtHelpCenter applicationId="design-sgmarkets" mailSubject="User message" />
              <Footer />
            </GlobalContext.Provider>
          </IntlProvider>
        </Router>
      </ErrorBoundary>
    </SgwtWidgetContextProvider>
  );
}
